import { render, staticRenderFns } from "./CloseBoldIcon.vue?vue&type=template&id=3a8279f4&"
import script from "./CloseBoldIcon.vue?vue&type=script&lang=js&"
export * from "./CloseBoldIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports